import React from 'react'
import { Dialog } from '@material-ui/core'
import { COLORES } from '../../../../../config/colores'
import ConfirmacionPesadoDestare from './ConfirmacionPesadoDestare'
import DialogoErrorPesado from '../../../components/pesado/DialogoErrorPesado'
import PesadoDestareChoferLectura from './PesadoDestareChoferLectura'

export default function PesadoDestareChofer0 (props) {
  const { show, cpe, pesoCabezal, onBlurInput, modo } = props

  return (
    <>
      {cpe && cpe.error
        ? <DialogoErrorPesado
          cpe={cpe}
          borrarCpe={props.borrarCpeDestare}
          show={cpe && cpe.error}
          onBlurInput={onBlurInput}
          updateShow={props.updateShowDestare}
          showToast={() => null}
        />
        : <></>
      }

      <PesadoDestareChoferLectura
        pesoCabezal={pesoCabezal}
        modo={modo}
        handleSubmit={props.handleSubmit}
        onBlurInput={onBlurInput}
      />

      <Dialog
        open={show}
        fullScreen
      >
        {!cpe
          ? <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              margin: 'auto'
            }}
          >
            <div className='loader' />
            <h4 style={{ color: COLORES.grey.dark, margin: '15px ' }} >
                  Procesando sus datos
            </h4>
          </div>
          : <ConfirmacionPesadoDestare
            cpe={cpe}
            updateShow={props.updateShow}
            showReimpresion={props.showReimpresion}
            reimpresionCerealAdherido={props.reimpresionCerealAdherido}
            reimprimirTicket={props.reimprimirTicket}
            borrarCpeDestare={props.borrarCpeDestare}
            updateShowDestare={props.updateShowDestare}
          />
        }
      </Dialog>

    </>
  )
}
